import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusAdvisorService, deleteAdvisorService, getAllAdvisorServices } from "../../../../api/advisorService";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";

function getData(advisorServices) {
    return advisorServices.map(advisorService => ({
        title: getNonEmpty(advisorService.title),
        description: getNonEmpty(advisorService.description),
        createdAt: advisorService.createdAt,
        active: advisorService.active,
        id: advisorService._id,
    }));
}

export default function AdvisorServicePage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [advisorService, setAdvisorService] = useState(null);

    useEffect(() => {
        getAllAdvisorServices()
            .then((res) => {
                setData(getData(res.data));
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get advisor services.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisableDelete(cell, "advisorService", data, user?.role === "admin", setAdvisorService, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        }
    ];

    return (
        <Card>
            <CardHeader title="Advisors services list">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-advisorService")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Table data={data} columns={columns} key={data.length} />

                <ConfirmDialog
                    title={`Are you sure you want to ${advisorService?.active ? "deactivate" : "activate"} this advisor service?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusAdvisorService(advisorService.id, !advisorService?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${advisorService?.active ? "Deactivate!" : "Activate!"
                                        }`,
                                    customMessage: `Advisor Service ${advisorService?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${advisorService?.active ? "deactivate" : "activate"
                                        } the advisor service.`,
                                });
                            });
                    }}
                />
                <ConfirmDialog
                    title={"Are you sure you want to delete this advisor service?"}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteAdvisorService(advisorService.id)
                            .then((res) => {
                                alertSuccess({
                                    title: "Deleted!",
                                    customMessage: "Technology deleted successfully.",
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: "Could not delete the advisor service.",
                                });
                            });
                    }}
                />
            </CardBody>
        </Card>
    );
}